import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SettingsHierarchy as SchemaSettingsHierarchy } from '../schemas/SettingsHierarchy';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetSettingsHierarchyContentType = '' as const;
export type GetSettingsHierarchyRequest = undefined;
export type GetSettingsHierarchyResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful get settings hierarchy
     */
    '200': {
        'application/json': SchemaSettingsHierarchy;
    };
};
export type GetSettingsHierarchyResponseSuccess = GetSettingsHierarchyResponses['200']['application/json'];
export type GetSettingsHierarchySearchParams = {
    paths: string[];
};
export type GetSettingsHierarchyPathParameters = {
    store_slug: string;
};
export const GetSettingsHierarchyUrl = '/{store_slug}/settings/describes' as const;
export const GetSettingsHierarchyMethod = 'GET' as const;
export const getGetSettingsHierarchyUrl = (params: GetSettingsHierarchyPathParameters) =>
    GetSettingsHierarchyUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetSettingsHierarchyPathParameters) =>
        String(params[param])
    );
